export function urlSearchToCachedObject(urlSearch: URLSearchParams): {
  environment: Array<[string, string]>;
} {
  const result = {};

  const advancedParams = urlSearch?.get('params');
  if (advancedParams) {
    try {
      // Handle complex mode
      // First try to decode the URL-encoded JSON if needed
      let paramsStr = advancedParams;

      // Check if the params appear to be URL-encoded
      if (advancedParams.includes('%')) {
        try {
          paramsStr = decodeURIComponent(advancedParams);
        } catch (decodeError) {
          // If decoding fails, try parsing the original string
          console.warn('Failed to decode URL parameters:', decodeError);
        }
      }

      const params = JSON.parse(paramsStr);

      // If we only want to extract environment variables (current implementation)
      const environmentRaw = params['environment'];
      if (environmentRaw && Array.isArray(environmentRaw) && environmentRaw.length > 0) {
        return {
          environment: environmentRaw,
        };
      }
    } catch (error) {
      console.warn('Failed to parse params JSON in URL params', error.message);
    }
  }

  urlSearch.forEach((value, key) => {
    // Match the key pattern: name[key]
    const matches = key.match(/^([^\[]+)\[([^\]]+)\]$/);

    if (matches) {
      const [, parent, child] = matches;
      // Create nested object if it doesn't exist
      result[parent] = result[parent] || [];
      // Add the value to nested object
      result[parent].push([child, value]);
    } else {
      // Handle regular keys
      result[key] = value;
    }
  });

  return result as unknown as {
    environment: Array<[string, string]>;
  };
}
